import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../lib/Errors';

let localSubscription = undefined;

function createSubscription(store) {
	let dataQuery = new Parse.Query('MedicationDoctorSpecialization');
	dataQuery.addAscending("specialization")
	dataQuery.find()
		.then((results) => {
			store.dispatch('doctorSpecialization/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
		dataQuery.subscribe().then((subscription) => {
		
		localSubscription = subscription;

		subscription.on('create', object => {
			
			store.dispatch('doctorSpecialization/insert', object)
		});
		subscription.on('update', object => {
			
			store.dispatch('doctorSpecialization/replace', object)
		});
		subscription.on('enter', object => {
			
			store.dispatch('doctorSpecialization/insert', object)
		});
		subscription.on('leave', object => {
			
			store.dispatch('doctorSpecialization/delete', object)
		});
		subscription.on('delete', object => {
			
			store.dispatch('doctorSpecialization/delete', object)
		});
		subscription.on('close', () => {
			
		});
		subscription.on('error', error => {
			
		})
	})
}

export default function createDoctorSpecializationSubscription() {
	return store => {
		if (store.state.currentUser) {
			createSubscription(store)
		}
		store.subscribe(mutation => {
			if (mutation.type === 'SET_CURRENT_USER') {
				if (localSubscription) {
					localSubscription.unsubscribe()
				}
				if (store.state.currentUser) {
					createSubscription(store)
				}
			}
		})
	}
}
